/**
 * EDELHOLZ -> Microsoft Clarity (15.09.2026, Marketing-Session, Philipp-OK)
 *
 * Reicht die Ereignisse des eigenen Beacons (edelholz-contact-hook.js Block 3, CustomEvent 'eh:track') an Clarity weiter.
 * Damit gelten in Clarity exakt dieselben Definitionen wie in unserem Dashboard.
 *
 * In Clarity:
 *  - Custom Events (Filter "Custom events"): konfig_schritt_1 ... konfig_schritt_7, konfig_warenkorb, konfig_angebot,
 *    konfig_leasing, konfig_ensemble, konfig_3d, kaufbox_schritt_2 ... _5, kaufbox_warenkorb, kaufbox_angebot,
 *    kaufbox_leasing, kaufbox_beratung, kaufbox_3d, beratung_offen, beratung_schritt_1 ... _4, beratung_gesendet,
 *    warenkorb, scroll_1_bild, scroll_3_bilder, scroll_6_bilder, scroll_12_bilder
 *  - Custom Tags (Filter "Custom tags"): eh_sid / eh_vid (= sid/vid in AdTrackEvent, Zuordnung Aufnahme <-> Beacon),
 *    eh_src (meta/google/organic/direct/utm), eh_ad (utm_content), konfig_max, kaufbox_max
 * Keine Klarnamen, keine Mailadressen.
 * 27.09.2026 Consent: Clarity laedt erst nach Einwilligung Statistik (snippets/edelholz-consent-apps.liquid setzt dann
 * window.__ehClarityOn). Vorher wird hier NICHTS gesendet oder gepuffert (kein Warteschlangen-Stub mehr), Tags werden
 * bei 'eh:clarity-an' nachgezogen. Nach Widerruf ist __ehClarityOn wieder false.
 *
 * Schrittnummern Konfigurator (/pages/konfigurator): 1 Modell, 2 Groesse, 3 Finish, 4 Kabel, 5 Einzelstueck,
 * 6 Zusammenfassung, 7 Ensemble. Kaufbox (Produktseiten): 2 Groesse, 3 Finish, 4 Features, 5 Add-ons.
 */
(function () {
  if (window.__ehClarityInit) return; window.__ehClarityInit = true;
  // Nur senden, solange Clarity per Einwilligung freigegeben ist. Kein eigener Stub: sonst laege vor der Wahl eine Warteschlange bereit.
  function an() { return window.__ehClarityOn === true && typeof window.clarity === 'function'; }
  function c() { if (!an()) return; try { window.clarity.apply(window, arguments); } catch (e) {} }

  // Zuordnung zum Beacon
  function tags() {
    if (!an()) return false;
    try {
      var a = (window.EdelholzAttribution && window.EdelholzAttribution.get()) || null;
      if (!a) return false;
      if (a.sid) c('set', 'eh_sid', String(a.sid));
      if (a.vid) c('set', 'eh_vid', String(a.vid));
      var src = (a.gclid || a.gbraid || a.wbraid || a.campaign_id) ? 'google' : ((a.fbclid || a.fbc) ? 'meta' : ((a.utm_source || a.utm_campaign || a.utm_content) ? 'utm' : (a.ref_host ? 'organic' : 'direct')));
      c('set', 'eh_src', src);
      if (a.utm_content) c('set', 'eh_ad', String(a.utm_content).slice(0, 80));
      return true;
    } catch (e) { return false; }
  }
  function tagsMitWiederholung() { if (!tags()) { var versuche = 0, iv = setInterval(function () { if (tags() || ++versuche > 20) clearInterval(iv); }, 500); } }
  if (an()) tagsMitWiederholung();
  window.addEventListener('eh:clarity-an', tagsMitWiederholung);

  // Ereignisse aus dem Beacon
  var max = { konfig: 0, kaufbox: 0 };
  window.addEventListener('eh:track', function (e) {
    try {
      var d = e.detail || {}, name = d.name, data = d.data || {};
      if (!name) return;
      if (data.step != null) {
        c('event', name + '_' + data.step);
        var bereich = name.split('_')[0];
        if (max[bereich] != null && data.step > max[bereich] && name.indexOf('_schritt') > -1) {
          max[bereich] = data.step; c('set', bereich + '_max', String(data.step));
        }
      } else {
        c('event', name);
      }
    } catch (x) {}
  });

  // Scroll-Meilensteine in Bildschirmhoehen (Clarity-Prozent sind auf langen Seiten kaum lesbar)
  var stufen = [[1, 'scroll_1_bild'], [3, 'scroll_3_bilder'], [6, 'scroll_6_bilder'], [12, 'scroll_12_bilder']], erreicht = 0;
  window.addEventListener('scroll', function () {
    try {
      var vh = window.innerHeight || 1, bilder = (window.scrollY || 0) / vh;
      while (erreicht < stufen.length && bilder >= stufen[erreicht][0]) { c('event', stufen[erreicht][1]); erreicht++; }
    } catch (x) {}
  }, { passive: true });
})();
